import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { PrivacyPolicyComponent } from "./privacy-policy.component";

const routes: Routes = [
    {
        path: 'privacyPolicy',
        component: PrivacyPolicyComponent,
        canLoad: [AuthGuard],
    }
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class PrivacyPolicyRoutingModule {}